<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-row>
          <b-col cols="3">
            <filtro-selecao-empresa
              @empresa-filtrada="getEmpresasFiltradas"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12">
      <totalizadores-empresa />
      <b-row align-v="stretch">
        <b-col cols="4">
          <b-card
            no-body
          >
            <b-card-header>
              <h4 class="mb-0">
                Situação fiscal
              </h4>
            </b-card-header>

            <b-card-body
              style="padding-bottom: 0.7rem;"
            >
              <!-- apex chart -->
              <vue-apex-charts
                type="radialBar"
                height="325"
                :options="situacaoFiscalData.chartOptions"
                :series="situacaoFiscalData.series"
              />
              <!-- chart info -->
              <div
                v-for="(data,key,index) in situacaoFiscalData.chartInfo"
                :key="key"
                class="d-flex justify-content-between"
                :class="index === Object.keys(situacaoFiscalData.chartInfo).length - 1 ? '':'mb-1'"
                @click.stop="redirecionaGrid(index)"
              >
                <div
                  class="series-info d-flex align-items-center"
                  style="cursor: pointer"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-circle"
                    :class="key === 'Total' ? 'text-primary': key === 'Regular' ? 'text-success': key==='Sem Situação Fiscal'?'text-warning':'text-danger'"
                  />
                  <span
                    style="font-size: 16px"
                    class="font-weight-bold text-capitalize ml-75"
                  >{{ key }}</span>
                </div>

                <span style="font-size: 18px">{{ data }}</span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="8">
          <b-card
            no-body
          >
            <b-card-header>
              <h4 class="mb-0">
                Pendências Situação Fiscal
              </h4>
            </b-card-header>

            <b-card-body
              style="padding-bottom: 0.7rem;"
            >
              <b-card-body>
                <vue-apex-charts
                  type="bar"
                  height="380"
                  :options="pendenciaSituacaoFiscalData.chartOptions"
                  :series="pendenciaSituacaoFiscalData.series"
                />
              </b-card-body>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          :cols="permissoes.includes('parcelamento') ? '6' : '12'"
        >
          <b-card
            no-body
          >
            <b-card-header>
              <b-card-title>DCTFWeb</b-card-title>
              <h5>{{ dctfWebData.total }} Declarações</h5>
              <div>
                <b-select
                  v-model="dctfWebAno"
                  name="filtroSelecao"
                  class="search-items"
                  style="float:right;"
                  @select="placeholder = false"
                  @input="atualizarDashDctfWeb"
                >
                  <option
                    v-for="(filtro, index) in anosDctfWeb"
                    :key="index"
                    :value="filtro"
                  >
                    {{ filtro }}
                  </option>
                </b-select>
              </div>
            </b-card-header>
            <b-card-body>
              <vue-apex-charts
                type="bar"
                :options="dctfWebData.chartOptions"
                :series="dctfWebData.series"
                height="285"
              />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col v-if="permissoes.includes('parcelamento')" :cols="isDemo ? 6 : 12">
          <b-card no-body>
            <b-card-header>
              <b-card-title>Parcelamentos</b-card-title>
              <b-badge
                v-if="showAvisoConfirmacao"
                :variant="'light-danger'"
              >
                RELP: Confirmação Remanescentes
              </b-badge>
            </b-card-header>
            <b-card-body>
              <vue-apex-charts
                type="bar"
                :options="parcStatusData.chartOptions"
                :series="parcStatusData.series"
                height="300"
              />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-v="stretch">
        <b-col
          v-if="isDemo"
          :cols="permissoes.includes('cnd_estadual') ? '4' : '6'"
          style="max-height: 418;"
        >
          <totalizadores-caixapostal />
        </b-col>
        <b-col
          :cols="permissoes.includes('cnd_estadual') ? '8' : '6'"
        >
          <b-card
            class="card-transaction grafico-view"
            no-body
          >
            <b-card-header>
              <h4>
                CNDs
              </h4>
            </b-card-header>

            <b-card-body
              style="padding-bottom: 0.7rem;"
            >
              <b-card-body>
                <vue-apex-charts
                  type="bar"
                  :options="cndsData.chartOptions"
                  :series="cndsData.series"
                  height="553"
                />
              </b-card-body>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss" >
.swal-m {
  width: 35%;
}

.yaxis-espacamento-titulo {
  letter-spacing: 0.125rem;
}
</style>

<script>
// import { isDemo } from '@/auth/utils'
import { defineComponent } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// eslint-disable-next-line
import { useRouter } from '@core/utils/utils'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
// eslint-disable-next-line
import useParcAtrasado from './shared/components/useParcelamentoStatus'
// eslint-disable-next-line
import useSituacaoFiscal from './shared/components/useSituacaoFiscal'
// eslint-disable-next-line
import useDctfWeb from './shared/components/useDctfWeb'
// eslint-disable-next-line
import useCnds from './shared/components/useCnds'
// eslint-disable-next-line
import usePendenciaSituacaoFiscal from './shared/components/usePendenciaSituacaoFiscal'
import './shared/style/analitico.scss'

export default defineComponent({
  components: {
    VueApexCharts,
    FontAwesomeIcon,
    TotalizadoresEmpresa: () => import('./shared/components/totalizadores-empresa/TotalizadoresEmpresa.vue'),
    TotalizadoresCaixapostal: () => import('./shared/components/totalizadores-caixapostal/TotalizadoresCaixaPostal.vue'),
    FiltroSelecaoEmpresa: () => import('./shared/components/filtro-selecao-empresa/FiltroSelecaoEmpresa.vue'),
  },
  computed: {
    showAvisoConfirmacao() {
      let dataLimite = new Date()
      dataLimite = dataLimite.setMonth(1, 28)
      dataLimite += 60

      return new Date() < dataLimite
    },

    anosDctfWeb() {
      const currentYear = new Date().getFullYear()
      const years = []
      let startYear = 2018

      while (startYear <= currentYear) {
        years.push(startYear)
        startYear += 1
      }
      return years
    },
  },
  created() {
    if (this.$route.params.primeiroAcesso) {
      this.$swal({
        title: '<div style="color:red;">Instabilidade API e-CAC</div>',
        html: `
          '<div style="color:red; font-size: 18px;">
            Olá!
            <br>
            Informamos que estamos <b>enfrentando instabilidades temporárias na integração com a API do e-CAC</b>, o que pode causar lentidão ou dificuldades no acesso a algumas informações.
            Nossa equipe técnica já está ciente da situação e atua ativamente para normalizar os serviços o mais breve possível.
            Reforçamos nosso compromisso com a estabilidade e transparência, e manteremos você informado(a) sobre qualquer atualização relevante.
            Caso precise de suporte adicional, nossa equipe está à disposição para ajudar.
            <br><br><br>
            <b>Atenciosamente
            Equipe Monitor Contábil</b>
            </div>'
        `,
        icon: 'warning',
        iconColor: '#FF0000',
        showConfirmButton: false,
        width: '30%',
        customClass: {
          popup: 'swal-m',
        },
      })
    }
  },
  data() {
    return {
      permissoes: localStorage.getItem('permissoes'),
    }
  },
  methods: {
    atualizarDashDctfWeb() {
      this.dado = useDctfWeb(this.dctfWebAno, this.filtros, this.routerDctf)

      this.dctfWebData = this.dado.dadosDctfWebStatus.value

      this.dctfWebAno = this.dado.anoDash.value
    },
    getEmpresasFiltradas(empresas) {
      this.filtros.empresas = empresas
      this.aplicarFiltro()
    },
    aplicarFiltro() {
      EventBus.$emit('filtrosDashboardAtualizados', this.filtros)

      this.parcStatusData = useParcAtrasado(this.filtros, this.routerParcelamento).dadosParcStatus.value

      this.situacaoFiscalData = useSituacaoFiscal(this.filtros, this.routerSituacaoFiscal).dadosSituacaoFiscal.value

      this.pendenciaSituacaoFiscalData = usePendenciaSituacaoFiscal(this.filtros, this.routerPendenciaSituacaoFiscal).dadosPendenciaSituacaoFiscal.value

      this.cndsData = useCnds(this.filtros, this.routerCnds).dadosCnds.value

      this.atualizarDashDctfWeb()
    },
  },
  setup() {
    const { router } = useRouter()

    const filtros = { empresas: [] }

    const { dadosParcStatus, routerParcelamento } = useParcAtrasado(filtros)
    const { dadosSituacaoFiscal, routerSituacaoFiscal } = useSituacaoFiscal(filtros)
    const { dadosPendenciaSituacaoFiscal, routerPendenciaSituacaoFiscal } = usePendenciaSituacaoFiscal(filtros)
    const { dadosCnds, routerCnds } = useCnds(filtros)
    const { dadosDctfWebStatus, anoDash, routerDctf } = useDctfWeb(new Date().getFullYear(), filtros)

    const redirecionaGrid = index => {
      if (index === 0) {
        router.push({ name: 'situacaofiscal-view', query: { filtroEmpresa: filtros.empresas } })
      } else if (index === 1) {
        router.push({ name: 'situacaofiscal-view', param: { query: true }, query: { filtroRapido: 'Regular', filtroEmpresa: filtros.empresas } })
      } else if (index === 2) {
        router.push({ name: 'situacaofiscal-view', param: { query: true }, query: { filtroRapido: 'SemSituacao', filtroEmpresa: filtros.empresas } })
      } else if (index === 3) {
        router.push({ name: 'situacaofiscal-view', param: { query: true }, query: { filtroRapido: 'Irregular', filtroEmpresa: filtros.empresas } })
      }
    }
    const isDemo = true

    return {
      parcStatusData: dadosParcStatus,
      situacaoFiscalData: dadosSituacaoFiscal,
      pendenciaSituacaoFiscalData: dadosPendenciaSituacaoFiscal,
      cndsData: dadosCnds,
      dctfWebData: dadosDctfWebStatus,
      dctfWebAno: anoDash,
      redirecionaGrid,
      isDemo,
      routerParcelamento,
      routerSituacaoFiscal,
      routerPendenciaSituacaoFiscal,
      routerCnds,
      routerDctf,
      filtros,
    }
  },
})
</script>
